package com.eladfinish.bible.contest.screens.search.suggestions

import com.eladfinish.contract.suggestions.SearchSuggestionsSnapshot
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.url

/** Downloads the popular-searches snapshot the server publishes (see `server/README.md`). */
fun interface PopularSearchesApi {

    suspend fun fetch(url: String): Result<SearchSuggestionsSnapshot>
}

class KtorPopularSearchesApi(
    private val client: HttpClient,
) : PopularSearchesApi {

    override suspend fun fetch(url: String): Result<SearchSuggestionsSnapshot> =
        runCatching {
            client.get {
                url(url)
            }.body()
        }
}
